module.exports = {
    userRoles: {
        admin: 'Administrateur',
        dispatch: 'Dispatch',
        driver: 'Chauffeur',
        subcontractor: 'Sous-traitant',
        exclusiveSubcontractor: 'Sous-traitantExclusif',
        other: 'Autre',
        viewer: 'Viewer'
    }
}
